'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/menu/style/css.js
// module id = 450
// module chunks = 0